// Shared severity + channel labels for the notification settings UIs (R40 2c).
export const SEVERITIES = [
  { value: 'critical', label: 'Critical' },
  { value: 'material', label: 'Material' },
  { value: 'minor', label: 'Minor' },
  { value: 'informational', label: 'Informational' },
]

export const CHANNELS = [
  { value: 'in_app', label: 'In-app' },
  { value: 'email', label: 'Email' },
  { value: 'slack_dm', label: 'Slack DM' },
  { value: 'daily_digest', label: 'Daily digest' },
  { value: 'weekly_digest', label: 'Weekly digest' },
]
